<template>
  <small class="text-muted"><slot/></small>
</template>